import { WEBSITE_URL } from '../constants/APIConstants';
import ky from './kyextended';

const getAgents = (webId) => ky.get(`${WEBSITE_URL}${webId}/agents/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const addAgent = (webId, agentData) => ky.post(`${WEBSITE_URL}${webId}/agents/`, {
    json: agentData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateAgent = (webId, agentId, agentData) => ky.patch(`${WEBSITE_URL}${webId}/agents/${agentId}/`, {
    json: agentData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const deleteAgent = (webId, agentId) => ky.delete(`${WEBSITE_URL}${webId}/agents/${agentId}/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export { getAgents, addAgent, updateAgent, deleteAgent }